// Region ID to display label mapping (no periods in keys)
export const REGION_LABELS = {
  GLOBALTOTALS: 'GLOBAL TOTALS',
  NORTHAMERICA: 'NORTH AMERICA',
  LATINAMERICA: 'LATIN AMERICA',
  EUROPE: 'EUROPE',
  MIDDLEEAST: 'MIDDLE EAST',
  AFRICA: 'AFRICA',
  ASIA: 'ASIA',
  CHINA: 'CHINA',
  CIS: 'C.I.S.',
  OPEC: 'OPEC',
  OPECPLUS: 'OPEC+',
  OECD: 'OECD',
};
import countriesDictionary from './countriesDictionary.js';

/**
 * Region Country Dictionary - Country Classifications by Region
 * All countries organized by major geographical/economic regions
 */

// Helper to build region objects
function buildRegion(countries) {
  const obj = {};
  for (const iso_code of countries) {
    const iso = countriesDictionary[iso_code] || iso_code;
    obj[iso] = { name: iso_code };
  }
  return obj;
}

const _REGIONS = {
  "CIS" : {
    label: "CIS",
  }
}

const _COUNTRIES_BY_REGION = {
  "GLOBAL TOTALS": [
    "CT",
    "OP",
    "ZO",
    "OU",
    "ON",
    "OA",
    "LM",
    "AA",
    "PP",
    "DD",
  ],
  "REGIONAL TOTALS": [
    "ZN",
    "ZL",
    "ZF",
    "ZE",
    "ZC",
    "WA",
    "WN",
    "ZT",
    "ZP",
    "CN"
  ],
  "NORTH AMERICA": [
    "CA", // Canada
    "US",  // United States of America
    "ZN"
  ],
  "LATIN AMERICA": [
    "AG", "AR", "AN", "BB", "BS", "BO", "BR", "CL", "CO", "CR", "CU", "DO", "EC", "SV", "GT", "GY", "HT", "HN", "JM", "MX", "NI", "PA", "PR", "PY", "PE", "SR", "TT", "UY", "VE", "OT", "ZL", "VI"
  ],
  "EUROPE": [
    "AL", "AT", "BE", "BA", "BG", "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IS", "IE", "IT", "LV", "LT", "LU", "MT", "ME", "NL", "MK", "NO", "PL", "PT", "RO", "SM", "RS", "SK", "SI", "ES", "SE", "CH", "GB", "MQ",
    "GI", "CY", "OE", "ZT", "EU", "EN", "EM"
  ],
  "MIDDLE EAST": [
    "BH", "IR", "IQ", "IL", "JO", "KW", "LB", "OM", "QA", "SA", "SY", "TR", "AE", "YE", "ZE", "ZZ"
  ],
  "AFRICA": [
    "DZ", "AO", "BJ", "BW", "BF", "BI", "CM", "CV", "CF", "TD", "KM", "CD", "CG", "DJ", "EG", "GQ", "ER", "SZ", "ET", "GA", "GM", "GH", "GN", "GW", "CI", "KE", "LS", "LR", "LY",
    "MG", "MW", "ML", "MR", "MU", "MA", "MZ", "NA", "NE", "NG", "RW", "ST", "SC", "SN", "SL", "SO", "ZA", "SS", "SD", "TZ", "TG", "TN", "UG", "ZM", "ZW", "ZF", "WN", "WA"
  ],
  "ASIA": [
    "AF", "BD", "BN", "KH", "CN", "HK", "IN", "ID", "JP", "KP", "KR", "MY", "MM", "NP", "PK", "PH", "PG", "SG", "LK", "TH", "VN", "TW", "ZP", "OS", "NN", "IA", "AP"
  ],
  "CHINA": [
    "CN"
  ],
  "CIS": [
    "OC", "AM", "AZ", "BY", "GE", "KZ", "KG", "MD", "RU", "TJ", "TM", "UA", "UZ", "OC", "ZC"
  ],
  "OPEC": [
    "OP", "DZ", "CG", "GQ", "GA", "IR", "IQ", "KW", "LY", "NG", "SA", "VE"
  ],
  "OPEC+": [
    "OO", "DZ", "CG", "GQ", "GA", "IR", "IQ", "KW", "LY", "NG", "SA", "VE",
    "AZ", "BH", "BN", "BR", "KZ", "MY", "MX", "OM", "RU", "SD", "SS"
  ],
  "OECD": [
    "OD", "AU", "AT", "BE", "CA", "CL", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IS", "IE", "IL", "IT", "JP", "KR", "LV", "LT", "LU", "MX", "NL", "NZ", "NO", "PL", "PT", "SK", "SI", "ES", "SE", "CH", "TR", "GB", "US"
  ]
}

// Utility functions for working with the country data
export const getAllCountries = () => {
  return Object.values(_COUNTRIES_BY_REGION).flatMap(regionObj => Object.values(regionObj));
};

// Get countries by region (or all if no region specified)
export const getCountriesByRegion = (region = null) => {
  if (!region) return _COUNTRIES_BY_REGION;

  return _COUNTRIES_BY_REGION[region.toUpperCase()] || {};
};

// Get region by country ISO code
export const getRegionByCountry = (isoCode) => {
  for (const [region, countriesObj] of Object.entries(_COUNTRIES_BY_REGION)) {
    if (Object.keys(countriesObj).includes(isoCode)) {
      return region;
    }
  }
  return null;
};

// Get all regions
export const getRegions = () => {
  return Object.keys(_COUNTRIES_BY_REGION);
};

export const COUNTRIES_BY_REGION = (() => {
  const result = {};
  for (const [region, isoCodes] of Object.entries(_COUNTRIES_BY_REGION)) {
    result[region] = isoCodes.map(iso => ({
      iso,
      ...countriesDictionary[iso],
      value: iso,
    }));
  }
  return result;
})()

export const getCountriesByRegionSimple = () => {
  return COUNTRIES_BY_REGION;
}